module.exports = __webpack_public_path__ + "as.23e6ae7d55de10776260.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/as.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/as.svg
// module chunks = styles